import React, {useContext} from 'react';
import { useTranslate } from 'react-redux-multilingual';
import { IsAuthContext } from 'app/App';

const ModalKiosque = (props) =>{
    const t = useTranslate(); //Traduction
    const { authParam } = useContext(IsAuthContext); //AuthParams

    let formattedDateBegin = null
    let formattedDateEnd = null

    // Formatage dates
    if (props.abonnementCard?.date_begin!=null) {
        let dateBegin = new Date(props.abonnementCard?.date_begin)
        const day = String(dateBegin.getUTCDate()).padStart(2, '0'); // Obtenez le jour
        const month = String(dateBegin.getUTCMonth() + 1).padStart(2, '0'); // Obtenez le mois (ajoutez 1 car les mois sont indexés à partir de 0)
        const year = dateBegin.getUTCFullYear(); // Obtenez l'année.
        formattedDateBegin = `${day}/${month}/${year}`;
    }

    if (props.abonnementCard?.date_end!=null) {
        let dateEnd = new Date(props.abonnementCard?.date_end)
        const day = String(dateEnd.getUTCDate()).padStart(2, '0'); // Obtenez le jour
        const month = String(dateEnd.getUTCMonth() + 1).padStart(2, '0'); // Obtenez le mois (ajoutez 1 car les mois sont indexés à partir de 0)
        const year = dateEnd.getUTCFullYear(); // Obtenez l'année.
        formattedDateEnd = `${day}/${month}/${year}`;
    }
    // end

    return(
    <>
        <div
            style={{ 
                height: '100%', 
                width: '100%', 
                display: 'flex', 
                flexDirection: 'column' 
            }}
        >
            {(props.client) &&
                <div className="p-12 d-flex flex-column justify-content-center align-items-center" style={{color:"black", fontSize:"30px", flex:"1", backgroundColor:"#28C76E"}}>
                    {(props.client.photo) &&
                        <div className='mb-3 d-flex justify-content-center align-items-center'>
                            <div>
                                <img className="img-fluid mb-2 mt-2" src={process.env.REACT_APP_API_URL+'images/'+props.client.photo} style={{height: "100px"}} />
                            </div>
                        </div>
                    }
                    <div className='row'>
                        {props.client.name+" "+((props.client.firstname) ? props.client.firstname : '')}
                    </div>
                    <div className='row'>
                        {props.abonnementCard.abonnement_achat_article?.name}
                    </div>
                    {props.selected && 
                        <div className='row'>
                            {props.selected}
                        </div>
                    }
                    <div className='d-flex flex-column justify-content-center align-items-center'>
                        {(props.abonnementCard?.credit_disponible!=null && <span>{t('availableCredit') + ': ' + props.abonnementCard?.credit_disponible}</span>)}
                        {((props.abonnementCard?.date_begin!=null && props.abonnementCard?.date_end!=null) && 
                            <>
                                <span>{t('dateBeginAbonnement') + ": " + formattedDateBegin}</span>
                                <span>{t('dateEndAbonnement') + ": " + formattedDateEnd}</span>
                            </>
                        )}
                    </div>
                </div>
            }
            {(props.error) &&
                <div className="p-12 d-flex flex-column justify-content-center align-items-center" style={{color:"black", fontSize:"30px", flex:"1", backgroundColor:"#f74f4fff"}}>
                    {t(props.error)}
                </div>
            }
        </div>
    </>)
}

export default ModalKiosque;